import gql from 'graphql-tag';

export default gql`
  mutation sandboxVikaCopyDatasheetToMySpace($shareId: String!, $userId: String!) {
    sandboxVikaCopyDatasheetToMySpace(shareId: $shareId, userId: $userId) {
      nodeId
    }
  }
`;
